// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2fppO","obliqueLineWrap":"membershipbadge_obliqueLineWrap__zFzOT","obliqueLine":"membershipbadge_obliqueLine__1zhYo"};